import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery, pyrotchBaseUrl } from "../axios/AxiosInstance";

export interface EmailSettings {
  id?: number;
  fromEmail?: string;
  fromName?: string;
  host: string;
  port: number;
  username?: string;
  password?: string;
  passwordConfigured?: boolean;
  smtpAuth: boolean;
  startTls: boolean;
  enabled: boolean;
  productionRequestCreatedEnabled?: boolean;
  productionRevisionRequestedEnabled?: boolean;
  productionCancellationRequestedEnabled?: boolean;
  productionFollowUpEnabled?: boolean;
  productionEscalationEnabled?: boolean;
  procurementRequisitionEnabled?: boolean;
  todoSummaryEnabled?: boolean;
  chatEmailEnabled?: boolean;
  testRecipient?: string;
  internalFromEmail?: string;
  internalFromName?: string;
  internalProtocol?: string;
  internalSmtpHost?: string;
  internalSmtpPort?: number;
  internalHost?: string;
  internalPort?: number;
  internalPop3Host?: string;
  internalPop3Port?: number;
  internalUsername?: string;
  internalPassword?: string;
  internalPasswordConfigured?: boolean;
  internalSmtpAuth?: boolean;
  internalStartTls?: boolean;
  internalTestRecipient?: string;
  internalMailRecipients?: string;
  externalMailRecipients?: string;
  productionTeamEmails?: string;
  escalationEmails?: string;
  productionMetalInternalEmails?: string;
  productionMetalExternalEmails?: string;
  productionWoodInternalEmails?: string;
  productionWoodExternalEmails?: string;
  escalationMetalEmails?: string;
  escalationWoodEmails?: string;
  procurementCdToEmails?: string;
  procurementCdCcEmails?: string;
  procurementCcrToEmails?: string;
  procurementCcrCcEmails?: string;
}

export const EmailSettingsApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: pyrotchBaseUrl + "v1/",
  }),
  reducerPath: "emailSettingsApi",
  tagTypes: ["EmailSettings"],
  endpoints: (build) => ({
    getEmailSettings: build.query<EmailSettings, void>({
      query: () => ({
        url: "master-configuration/email-settings",
        method: "GET",
      }),
      providesTags: ["EmailSettings"],
    }),
    updateEmailSettings: build.mutation<EmailSettings, EmailSettings>({
      query: (payload) => ({
        url: "master-configuration/email-settings",
        method: "PUT",
        data: payload,
      }),
      invalidatesTags: ["EmailSettings"],
    }),
    sendTestEmail: build.mutation<boolean, void>({
      query: () => ({
        url: "master-configuration/email-settings/test",
        method: "POST",
      }),
    }),
    sendInternalTestEmail: build.mutation<boolean, void>({
      query: () => ({
        url: "master-configuration/email-settings/internal-test",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useGetEmailSettingsQuery,
  useUpdateEmailSettingsMutation,
  useSendTestEmailMutation,
  useSendInternalTestEmailMutation,
} = EmailSettingsApi;
